import { render, staticRenderFns } from "./AccountDetail.vue?vue&type=template&id=f0ba9062&"
import script from "./AccountDetail.vue?vue&type=script&lang=js&"
export * from "./AccountDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports